import styled from 'styled-components'

const VideoStyle = styled.div`
	--iconSize: var(--sp11x);

	&.videoCont {
		position: relative;

		@media (hover: hover) {
			&:hover {
				.play-button {
					&.paused {
						opacity: 1;
					}
				}
			}
		}

		.play-button {
			position: absolute;
			top: 50%;
			left: 50%;
			font-size: var(--iconSize);
			opacity: 1;
			transform: translate(-50%, -50%);
			transition: var(--trTime);
			z-index: 1;
			cursor: pointer;

			&.paused {
				opacity: 0;
			}

			&:before {
				color: var(--secondaryColor1);
			}
		}

		.video {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			z-index: 1;
			object-fit: cover;
			object-position: center;
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) =>
        theme.mediaQuery.DesktopSizeXLMin}) {
		--iconSize: var(--sp9x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) =>
        theme.mediaQuery.DesktopSizeLMin}) {
		--iconSize: var(--sp8x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) =>
        theme.mediaQuery.DesktopSizeMMin}) {
		--iconSize: var(--sp8x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) =>
        theme.mediaQuery.DesktopSizeSMin}) {
		--iconSize: var(--sp7x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) =>
        theme.mediaQuery.DesktopSizeXSMin}) {
		--iconSize: var(--sp5x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) =>
        theme.mediaQuery.TabletSizeMin}) {
		--iconSize: var(--sp5x);
	}

	@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--iconSize: var(--sp5x);
	}
`
export default VideoStyle
